export class LoadProductsForBrand {
    static readonly type = '[Products] Load Products For Brand';
    constructor(public brandId: number) {}
}
